import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { useExperience } from '../../contexts/ExperienceContext';
import { competitorAreas } from '../../data/journeys';
import { needById } from '../../data/needs';
import { ProductPanel } from '../ProductPanel';
import { Advance } from '../ui/Advance';
import { Eyebrow, RevealText, Stage } from '../ui/Stage';

/** Discovery, not correction: the answer may already be in the family. */
export function CloserStage() {
  const {
    signals,
    next,
    direction
  } = useExperience();
  const [shown, setShown] = useState(false);
  const choice = competitorAreas.find(item => item.id === signals.competitorArea);
  const isCovered = choice?.id === 'nowhere';
  const need = needById(isCovered ? 'flow' : choice?.need);
  useEffect(() => {
    const timer = window.setTimeout(() => setShown(true), 1500);
    return () => window.clearTimeout(timer);
  }, []);
  return <Stage direction={direction} className="min-h-screen py-28 sm:py-32" labelledBy="closer-title" data-id="element-176" data-mp="2tqfrdfnv69p4">
      <div className="max-w-4xl" data-id="element-177" data-mp="3p4iwelz6hxka">
        <Eyebrow accent={need.accent} data-id="element-178" data-mp="3twsexgxyrvcj">
          {isCovered ? 'Already covered' : `Currently outside Filtek · ${choice?.label ?? ''}`}
        </Eyebrow>

        <h2 id="closer-title" className="display-tight mt-9 text-[2rem] font-light text-enamel sm:text-[2.9rem] lg:text-[3.5rem]" data-id="element-179" data-mp="3g6owz264answ">
          <RevealText text={isCovered ? 'Then the only question left is what else the family could cover.' : 'You may already have the solution closer than you think.'} delay={0.25} data-id="element-180" data-mp="coyhpiczr3oo" />
        </h2>

        <motion.p className="mt-9 max-w-xl text-lede font-light text-mute" initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.9,
        delay: 1
      }} data-id="element-181" data-mp="7pc2529oxbcp">
          {isCovered ? 'Most clinicians meet one part of Filtek first. This is the part that tends to arrive last.' : `The Filtek Family already has a solution built for ${need.label.toLowerCase()} — the same
               chemistry family, the same shade logic, one system.`}
        </motion.p>
      </div>

      <AnimatePresence data-id="element-182" data-mp="1zjtv9uc4y7ry">
        {shown && <motion.div initial={{
        opacity: 0,
        y: 24
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="mt-14 max-w-3xl" data-id="element-183" data-mp="1umbni79utylj">
            <ProductPanel productId={need.productId} companionId={need.companionId} accent={need.accent} eyebrow={`Inside the family · ${need.label}`} data-id="element-184" data-mp="1kn2tjeezojz6" />
            <div className="mt-10" data-id="element-185" data-mp="1bp0kqcp0kn1c">
              <Advance label="See the whole family" onClick={next} accent={need.accent} data-id="element-186" data-mp="3b0juuum201cl" />
            </div>
          </motion.div>}
      </AnimatePresence>
    </Stage>;
}